import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/people-fill";
import shoppingBagFill from "@iconify/icons-eva/shopping-bag-fill";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import lockFill from "@iconify/icons-eva/lock-fill";
import personFill from "@iconify/icons-eva/person-fill";
import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import videoSecurity20Filled from "@iconify/icons-fluent/video-security-20-filled";
import mailProhibited20Filled from "@iconify/icons-fluent/mail-prohibited-20-filled";
import usersIcon from "@iconify/icons-fa-solid/users";
import settings2Fill from "@iconify/icons-eva/settings-2-fill";
import animalCat16Filled from "@iconify/icons-fluent/animal-cat-16-filled";
import plantFill from "@iconify/icons-ri/plant-fill";
import notListedLocation from "@iconify/icons-material-symbols/not-listed-location";
import step16Regular from "@iconify/icons-fluent/step-16-regular";
import baselineProductionQuantityLimits from "@iconify/icons-ic/baseline-production-quantity-limits";
import baselineModelTraining from "@iconify/icons-ic/baseline-model-training";
import outlineAddTask from "@iconify/icons-ic/outline-add-task";
import detailIcon from "@iconify/icons-bx/detail";
import discountIcon from "@iconify/icons-ic/baseline-local-offer";
// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: "Steps",
    path: "/steps",
    icon: getIcon(step16Regular),
  },
  {
    title: "Products",
    path: "/products",
    icon: getIcon(baselineProductionQuantityLimits),
  },
  {
    title: "Models",
    path: "/models",
    icon: getIcon(baselineModelTraining),
  },
  {
    title: "Additional",
    path: "/additional",
    icon: getIcon(outlineAddTask),
  },
  {
    title: "Details",
    path: "/details",
    icon: getIcon(detailIcon),
  },
  {
    title: "Received Orders",
    path: "/receivedorders",
    icon: getIcon("ant-design:shopping-outlined"),
  },
  {
    title: "Members",
    path: "/members",
    icon: getIcon("ph:users-three-light"),
  },
  {
    title: "Discount Codes",
    path: "/discount-codes",
    icon: getIcon(discountIcon),
  },
];

export default sidebarConfig;
